import { makeStyles } from 'tss-react/mui';

interface IProps {
  borderColor?: string;
}

const useStyles = makeStyles<IProps>()((theme, { borderColor }) => ({
  edgeGroup: {
    '& .MuiButton-root': {
      backgroundColor: theme.palette.background.paperNested + 'E6',
      borderColor: borderColor || theme.palette.primary.main,
      color: theme.palette.text.secondary,
      boxShadow: theme.shadows[3],
      ':hover': {
        backgroundColor: theme.palette.background.paperNested,
        borderColor: theme.palette.charts.primary.yellow,
        color: theme.palette.text.primary,
      },
    },
  },
}));

export default useStyles;
